import { Badge } from "@chakra-ui/react";

export const TestBadge = (props) => (
    <Badge bg="yellow.600" borderColor="yellow.300" borderWidth={1} variant="subtle" fontSize="xs" px={2} py={0.5} borderRadius={6} {...props}>
        TEST
    </Badge>
);

export default TestBadge;
